import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea4d760"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 row-cols-xl-4" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "align-self-end" }
const _hoisted_13 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = { class: "remark-text" }
const _hoisted_17 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("project_code")), 1)
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
        class: "mt-2",
        ref: "searchCriteriaFormRef",
        model: _ctx.searchCriteria,
        rules: _ctx.searchCriteriaFormRules,
        "label-position": 'right',
        "label-width": 'auto'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                prop: "periodNum",
                label: _ctx.t('period') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchCriteria.periodNum,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.periodNum) = $event)),
                    onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                    clearable: "",
                    placeholder: _ctx.t('placeholder.input')
                  }, null, 8, ["modelValue", "onKeyup", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('creator') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchCriteria.creatorKeyword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.creatorKeyword) = $event)),
                    onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                    clearable: "",
                    placeholder: _ctx.t('placeholder.input')
                  }, null, 8, ["modelValue", "onKeyup", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('startDate') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.searchCriteria.startDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCriteria.startDate) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "month",
                    placeholder: _ctx.t('placeholder.date'),
                    style: {"width":"100%"},
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('endDate') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.searchCriteria.endDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchCriteria.endDate) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "month",
                    placeholder: _ctx.t('placeholder.date'),
                    style: {"width":"100%"},
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          type: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClearSearchCriteriaClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearchperiodClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_10,
      (_ctx.userInfoStore.permissions.some((x) => x === 420))
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            justify: "end",
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 2,
                xs: 3,
                sm: 3,
                md: 2,
                lg: 2,
                xl: 2,
                class: "d-flex justify-content-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCreatePeriodClicked())),
                    disabled: !_ctx.userInfoStore.permissions.some((x) => x === 220)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("create")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_popover, {
            placement: "bottom",
            onHide: _ctx.onColDisplayCtrlPanelHidded,
            trigger: "click",
            Title: _ctx.t('column')
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { link: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { size: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Operation)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[0],
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("period")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[1],
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("creator")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[2],
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("createDate")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[3],
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("startMonth")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[4],
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("endMonth")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["onHide", "Title"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "periodTableRef",
          class: "w-100",
          stripe: true,
          data: _ctx.displayPeriods,
          onSortChange: _ctx.onSortChanged
        }, {
          default: _withCtx(() => [
            (_ctx.colDisplayCtrl[0])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  "min-width": "80",
                  sortable: "custom",
                  label: _ctx.t('period'),
                  prop: "periodNum"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[1])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('creator'),
                  prop: "creatorDisplayName"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[2])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 2,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('createDate'),
                  prop: "createTime"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[3])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 3,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('startMonth'),
                  prop: "startMonth"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[4])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 4,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('endMonth'),
                  prop: "endMonth"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              width: "80",
              label: _ctx.t('operation'),
              prop: "operate",
              class: "operateBtnGroup d-flex",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (_ctx.userInfoStore.permissions.some((x) => x === 420))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      link: "",
                      type: "success",
                      onClick: ($event: any) => (_ctx.onEditPeriodClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_EditPen)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      link: "",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.onViewperiodClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ZoomIn)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])),
                (_ctx.userInfoStore.permissions.some((x) => x === 420))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      link: "",
                      type: "danger",
                      onClick: ($event: any) => (_ctx.onDeletePeriodClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      link: "",
                      type: "info",
                      onClick: ($event: any) => (_ctx.onDeletePeriodClicked(scope.row)),
                      disabled: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "onSortChange"])), [
          [
            _directive_loading,
            _ctx.isTableLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _createVNode(_component_el_row, {
        justify: "end",
        class: "mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_pagination, {
                  currentPage: _ctx.currentPage,
                  "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentPage) = $event)),
                  "page-size": _ctx.pageSize,
                  "onUpdate:page-size": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pageSize) = $event)),
                  "pager-count": _ctx.paginatorSetup.pagerCount,
                  layout: _ctx.paginatorSetup.layout,
                  small: _ctx.paginatorSetup.small,
                  "page-sizes": [20, 50, 100],
                  total: _ctx.filteredPeriods.length,
                  onSizeChange: _ctx.onPagesizeChanged,
                  onCurrentChange: _ctx.onCurrentPageChanged,
                  justify: "end"
                }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowAddPeriodDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isShowAddPeriodDialog) = $event)),
      title: _ctx.t('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isShowAddPeriodDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onSubmitNewPeriodClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"])),
          ref: "addPeriodFormRef",
          model: _ctx.newPeriodData,
          rules: _ctx.addPeriodFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.creator'),
              prop: "creator",
              class: "text-nowrap col-lg-8 col-12",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.newPeriodData.creator?.displayName) + " (" + _toDisplayString(_ctx.newPeriodData.creator?.username) + ")", 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.period'),
              prop: "periodNum",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.newPeriodData.periodNum,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newPeriodData.periodNum) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.month_range'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "w-100",
                  modelValue: _ctx.newPeriodData.duration,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newPeriodData.duration) = $event)),
                  "unlink-panels": "",
                  "value-format": "YYYY-MM-DD",
                  type: "monthrange",
                  placeholder: _ctx.t('placeholder.date')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              class: "text-nowrap",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.newPeriodData.remark,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newPeriodData.remark) = $event)),
                  rows: 4,
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isAddDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowModifyPeriodDialog,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isShowModifyPeriodDialog) = $event)),
      title: _ctx.t('modify')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isShowModifyPeriodDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onSaveModifyResultClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"])),
          ref: "modifyPeriodFormRef",
          model: _ctx.selectedPeriodData,
          rules: _ctx.modifyPeriodFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.creator'),
              prop: "creator",
              class: "text-nowrap col-lg-8 col-12",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedPeriodData.creator?.displayName) + " (" + _toDisplayString(_ctx.selectedPeriodData.creator?.username) + ")", 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.period'),
              prop: "periodNum",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.selectedPeriodData.periodNum,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedPeriodData.periodNum) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.month_range'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "w-100",
                  modelValue: _ctx.selectedPeriodData.duration,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedPeriodData.duration) = $event)),
                  "value-format": "YYYY-MM-DD",
                  type: "monthrange",
                  "unlink-panels": "",
                  placeholder: _ctx.t('placeholder.date')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              class: "text-nowrap",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.selectedPeriodData.remark,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selectedPeriodData.remark) = $event)),
                  rows: 4,
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isModifyDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowViewPeriodDialog,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.isShowViewPeriodDialog) = $event)),
      title: _ctx.t('detail')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isShowViewPeriodDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["prevent"])),
          ref: "modifyPeriodFormRef",
          model: _ctx.selectedPeriodData,
          rules: _ctx.modifyPeriodFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.creator'),
              prop: "creator",
              class: "text-nowrap col-lg-8 col-12",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedPeriodData.creator?.displayName) + " (" + _toDisplayString(_ctx.selectedPeriodData.creator?.username) + ")", 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.period'),
              prop: "periodNum",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedPeriodData.periodNum), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.month_range'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.moment(_ctx.selectedPeriodData.duration[0]).format("YYYY-MM")) + " - " + _toDisplayString(_ctx.moment(_ctx.selectedPeriodData.duration[1]).format("YYYY-MM")), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              class: "text-nowrap",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.selectedPeriodData.remark), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isModifyDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}